import type {TriggerIntegration} from '@cohort/merchants/apps';
import DiscordHasRoleTriggerIntegrationStepCompletionTitleComponent from '@cohort/merchants/apps/discord/triggerIntegrations/hasRole/StepCompletionTitleComponent';
import useDiscordHasRoleTriggerIntegrationStepCompletionColumns from '@cohort/merchants/apps/discord/triggerIntegrations/hasRole/useStepCompletionColumns';
import type {DiscordHasRoleTriggerStruct} from '@cohort/shared/apps/discord/triggers/hasRole';
import {DiscordHasRoleTriggerIntegrationSpec} from '@cohort/shared/apps/discord/triggers/hasRole';

export const DiscordHasRoleTriggerIntegration: TriggerIntegration<DiscordHasRoleTriggerStruct> = {
  spec: DiscordHasRoleTriggerIntegrationSpec,
  stepCompletionTitleComponent: DiscordHasRoleTriggerIntegrationStepCompletionTitleComponent,
  useStepCompletionColumns: useDiscordHasRoleTriggerIntegrationStepCompletionColumns,
  getTitle: t => t('triggerIntegrations.has-role.title', {ns: 'app-discord'}),
};
